<template>
  <v-container>
    <base-subheading :subheading="$t('dashboard.basicInformation')" />
    <v-simple-table v-if="equipmentProfile && equipmentProfile.plant">
      <v-btn
        v-if="$store.getters['auth/equipmentWrite']"
        @click="
          $router.push({
            name: 'EquipmentProfile/EditProfile',
            params: { id: equipmentProfile.id }
          })
        "
        fab
        color="#730D0B"
        absolute=""
        top
        right=""
        ><v-icon color="white">mdi-pencil</v-icon></v-btn
      >
      <tbody>
        <tr>
          <td class="font-weight-bold">{{ $t("newEquipment.picture") }}</td>
          <td>
            <avatar :equipmentProfile="equipmentProfile"></avatar>
          </td>
        </tr>

        <tr>
          <td class="font-weight-bold">
            {{
              $t("newEquipment.equipmentStatus") ||
                $t("equipmentProfile.nocomment")
            }}
          </td>

          <td>
            <v-icon
              :color="
                equipmentProfile.status && equipmentProfile.status.color
                  ? equipmentProfile.status.color
                  : '#008450'
              "
              >mdi-circle</v-icon
            >
            {{
              equipmentProfile.status && equipmentProfile.status.name
                ? translate(equipmentProfile.status.name)
                : equipmentProfile.status
            }}
          </td>
        </tr>
        <tr>
          <td class="font-weight-bold">
            {{
              $t("newEquipment.mechanicalCondition") ||
                $t("equipmentProfile.nocomment")
            }}
          </td>

          <td>
            <v-icon :color="lastInspection ? lastInspection.color : '#008450'"
              >mdi-circle</v-icon
            >
            {{
              lastInspection
                ? translate(lastInspection.name)
                : $t("equipmentList.zones.smooth")
            }}
          </td>
        </tr>
        <tr>
          <td
            class="font-weight-bold"
            v-text="$t('dashboard.manufacturer')"
          ></td>
          <td>
            {{
              equipmentProfile.manufacturer || $t("equipmentProfile.nocomment")
            }}
          </td>
        </tr>
        <tr>
          <td class="font-weight-bold" v-text="$t('dashboard.model')"></td>
          <td>
            {{ equipmentProfile.model || $t("equipmentProfile.nocomment") }}
          </td>
        </tr>

        <tr>
          <td class="font-weight-bold">{{ $t("newEquipment.plant") }}</td>
          <td>
            {{
              equipmentProfile.plant.name || $t("equipmentProfile.nocomment")
            }}
          </td>
        </tr>
        <tr>
          <td class="font-weight-bold">{{ $t("newEquipment.area") }}</td>
          <td>
            {{ equipmentProfile.area.name || $t("equipmentProfile.nocomment") }}
          </td>
        </tr>
        <tr>
          <td class="font-weight-bold">{{ $t("newEquipment.unit") }}</td>
          <td>
            {{ equipmentProfile.unit.name || $t("equipmentProfile.nocomment") }}
          </td>
        </tr>
        <tr>
          <td class="font-weight-bold">
            {{ $t("newEquipment.equipmentType") }}
          </td>
          <td>
            {{ filterEquipmentType(equipmentProfile.equipmentType) }}
          </td>
        </tr>

        <tr>
          <td class="font-weight-bold">{{ $t("newEquipment.hazardous") }}</td>
          <td>
            {{ equipmentProfile.hazardous || $t("equipmentProfile.nocomment") }}
          </td>
        </tr>

        <tr>
          <td class="font-weight-bold">{{ $t("newEquipment.createdBy") }}</td>
          <td>
            {{ equipmentProfile.createdBy || $t("equipmentProfile.nocomment") }}
          </td>
        </tr>
        <tr>
          <td class="font-weight-bold">{{ $t("newEquipment.dateCreated") }}</td>
          <td>{{ equipmentProfile.dateCreated.toDate() | formatWithIntl }}</td>
        </tr>
        <!--  <tr>
          <td class="font-weight-bold">
            {{ $t("newEquipment.typeContract") }}
          </td>
          <td>
            {{ equipmentProfile.contract || "None" }}
          </td>
        </tr> -->

        <tr>
          <td class="font-weight-bold">
            {{ $t("newEquipment.comment") }}
          </td>
          <td>
            {{ equipmentProfile.comment || $t("equipmentProfile.nocomment") }}
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import equipmentType from "@/mixins/equipmentType";
export default {
  mixins: [equipmentType],
  components: {
    avatar: () => import("./Avatar.vue")
  },

  computed: {
    ...mapState("settings", ["equipmentType"]),
    ...mapState("equipments", ["equipmentProfile"]),
    /*      machineHealthIndex() {
      const operations = this.equipmentProfile?.lastInspection?.status;
      const reliabilities = this.equipmentProfile?.status;
      if (operations?.value > reliabilities?.value) {
        return operations;
      } else {
        return reliabilities;
      }
    },*/
    lastInspection() {
      return this.equipmentProfile?.lastInspection?.status;
    }
  },
  methods: {
    translate: function(item) {
      var temp = item;

      temp = temp.replace(
        "Running",
        this.$t("reliability.statuslights.running")
      );
      temp = temp.replace(
        "Standby",
        this.$t("reliability.statuslights.standby")
      );
      temp = temp.replace(
        "Maintenance",
        this.$t("reliability.statuslights.maintenance")
      );
      temp = temp.replace(
        "Failure",
        this.$t("reliability.statuslights.failure")
      );

      temp = temp.replace("Smooth", this.$t("reliability.conditions.smooth"));
      temp = temp.replace("Warning", this.$t("reliability.conditions.warning"));
      temp = temp.replace("Alarm", this.$t("reliability.conditions.alarm"));

      return temp;
    }
  }
};
</script>

<style>
.border-avatar {
  border: 4px solid #730d0b !important;
}
</style>
